import { SxProps, Theme } from '@mui/material';
import { CSSProperties } from 'react';
import { atlasSemantic, atlasCore } from 'src/theme/atlas/tokens';

export const container: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
};

export const leftGroup: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '12px',
  flex: 1,
};

export const searchField: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '320px',
};

export const searchLabel: SxProps<Theme> = {
  fontSize: '13px',
  color: atlasSemantic.color.type.muted,
};

export const filterButton: CSSProperties = {
  backgroundColor: atlasSemantic.color.action.secondary.hoverFill,
  border: 'none',
  color: atlasSemantic.color.type.default,
  fontWeight: 600,
};

export const resetButton: CSSProperties = {
  ...filterButton,
  backgroundColor: 'transparent',
};

export const toggleGroup: SxProps<Theme> = {
  '& .MuiToggleButtonGroup-grouped': {
    border: `1px solid ${atlasSemantic.color.action.secondary.outline}`,
    padding: `${atlasCore.spacing['0_5']} ${atlasCore.spacing['1_5']}`,
    margin: 0,
    textTransform: 'none',
    color: atlasSemantic.color.type.default,
  },
  '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
    borderLeftColor: 'transparent',
  },
  '& .MuiToggleButton-root.Mui-selected': {
    backgroundColor: atlasSemantic.color.action.primary.default,
    color: atlasSemantic.color.action.primary.onPrimary,
  },
  '& .MuiToggleButton-root.Mui-selected:hover': {
    backgroundColor: atlasSemantic.color.action.primary.default,
    color: atlasSemantic.color.action.primary.onPrimary,
  },
};
